import React from 'react';
import { NativeTranscriptEditorPageContextType } from './types';

const context = React.createContext<
  NativeTranscriptEditorPageContextType | undefined
>(undefined);

export default context;
